// packages
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";

const DEFAULT_THEME = {
  container: "",
  expandButton: {
    all: "",
    active: "bg-t-gray text-white",
    inactive: "bg-t-beige text-t-black",
  },
};

export default function Accordion({
  data,
  isFirstTabActive = false,
  theme = {},
}) {
  const activeTheme = _.merge({}, DEFAULT_THEME, theme);

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (isFirstTabActive) {
      setActiveTab(tabId(0));
    }
  }, []);

  const handleTabClick = (index) => {
    setActiveTab((prevTab) => (prevTab === tabId(index) ? null : tabId(index)));
  };

  const tabId = (index) => `accordion-body-${index}`;

  return (
    <div
      className={`${activeTheme.container}`}
      data-accordion="collapse"
      id="accordion"
    >
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <p id={`accordion-heading-${index + 1}`}>
            <button
              aria-controls={tabId(index)}
              aria-expanded={activeTab === tabId(index)}
              className={`${activeTheme.expandButton.all} ${
                activeTab === tabId(index)
                  ? activeTheme.expandButton.active
                  : activeTheme.expandButton.inactive
              } flex w-full items-start justify-between gap-2 px-2 pb-1 pt-2`}
              data-accordion-target={`#${tabId(index)}`}
              onClick={() => handleTabClick(index)}
              type="button"
            >
              <span className="flex items-center text-sm">{item.label}</span>
              {activeTab === tabId(index) ? (
                <MdOutlineExpandLess
                  className="shrink-0"
                  size="16"
                />
              ) : (
                <MdOutlineExpandMore
                  className="shrink-0"
                  size="16"
                />
              )}
            </button>
          </p>
          <div
            aria-labelledby={`accordion-heading-${index + 1}`}
            className={`${activeTab === tabId(index) ? "" : "hidden"}`}
            id={tabId(index)}
          >
            {item.content}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
